/* global gtag */
/* global DetectUserAgent */
import { useEffect, useMemo } from "react";

import { FETCH_STATUSES } from "enums";
import UserPresenter from "presenters/UserPresenter";
import MakePresenter from "presenters/MakePresenter";
import useUsers from "hooks/useUsers";
import useMakes from "hooks/useMakes";
import useExperiment from "hooks/useExperiment";
import useRouter from "hooks/useRouter";

const useGA4 = () => {
  const { currentUser, currentUserLoadingStatus } = useUsers();
  const { make } = useMakes();
  const { experimentId } = useExperiment();
  const {
    camelizedQuery: { landingDefaultBrowser },
  } = useRouter();

  const configParams = useMemo(() => {
    const config = {
      user_id: currentUser ? currentUser.id : null,
      user_properties: {
        loggedIn: UserPresenter.isRegistered(currentUser) ? "yes" : "no",
        statusMembership: UserPresenter.isPaid(currentUser) ? "member" : "nonMember",
        userIsRecipient: MakePresenter.isRecipient(make) ? "yes" : "no",
        experiment_id: experimentId || null,
        version: process.env.GIT_BRANCH,
        landing_default_browser: landingDefaultBrowser || null,
      },
    };

    return config;
  }, [currentUser, make, experimentId, landingDefaultBrowser]);

  useEffect(() => {
    if (DetectUserAgent.isPrerender()) return;

    if (currentUserLoadingStatus === FETCH_STATUSES.fulfilled) {
      gtag("set", "user_properties", configParams.user_properties);
      gtag("set", "user_id", configParams.user_id);
    }
  }, [configParams, currentUserLoadingStatus]);
};

export default useGA4;
